import { APICall } from "../../api_helper";
import { NewNewFormComponentProps } from "../new_form/NewNewFormComponent";
import {
  NewFormPageComponent,
  NewFormPageComponentProps,
} from "./NewFormPageComponent";
import {
  NewHardcodedPageComponent,
  NewHardcodedPageComponentProps,
} from "./NewHardcodedPageComponent";
import {
  NewListPageComponent,
  NewListPageComponentProps,
} from "./NewListPageComponent";
import {
  NewParentChildListPageComponent,
  NewParentChildListPageComponentProps,
} from "./NewParentChildListPageComponent";

export const NewPageComponent = (props: { props: NewPageComponentProps }) => {
  return (
    <>
      {props.props.type === "form" && (
        <NewFormPageComponent props={props.props} />
      )}
      {props.props.type === "parent_child_list" && (
        <NewParentChildListPageComponent props={props.props} />
      )}
      {props.props.type === "list_page" && (
        <NewListPageComponent props={props.props} />
      )}
      {props.props.type === "hardcoded_page" && (
        <NewHardcodedPageComponent props={props.props} />
      )}
    </>
  );
};

export type NewPageComponentProps =
  | NewFormPageComponentProps
  | NewParentChildListPageComponentProps
  | NewListPageComponentProps
  | NewHardcodedPageComponentProps;

export type ListPageCreationProps = {
  formComponentProps: NewNewFormComponentProps;
  apiCall: APICall;
};
